import React, { CSSProperties, memo, MouseEvent } from 'react';
import { datetime } from "../../../../../../../../util/library/datetime";
import { SHORT_TIME_FORMAT } from "../../../../../../../../util/varibles/constants";
import styles from "./style.module.scss";

interface TimelineData {
    id?: string
    name: 'start' | 'site' | 'factory' | 'finish'
    label: string
    title?: string
}

interface IProps {
    data: TimelineData
    isEdit: boolean
    time: number
    index: number
    style: CSSProperties
    isOverlap?: boolean

    handleMouseDown(e: MouseEvent, index: number): void
}

const TimePoint: React.FC<IProps> = ({ data, isEdit, style, time, index, isOverlap, handleMouseDown }) => {
    const { id, name, label, title } = data;
    const timelineStyle = { ...style, '--start-timeline': time } as CSSProperties;

    return <div {...{
        className: styles.timeline,
        style: timelineStyle,
        'data-edit': isEdit,
        'data-operation-id': id,
        'data-name': name,
        'data-overlap': isOverlap,
    }}>
        <span {...{
            title,
            onClick: (e) => e.stopPropagation(),
            onMouseDown: (e) => handleMouseDown(e, index)
        }}>
            {label}: {datetime(time).format(SHORT_TIME_FORMAT)}
        </span>
    </div>
};

export default memo(TimePoint);
